import { render, staticRenderFns } from "./ApplicantDashboard.vue?vue&type=template&id=9bd9dbd2&"
import script from "./ApplicantDashboard.vue?vue&type=script&lang=js&"
export * from "./ApplicantDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports